import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Grid, TextField, Typography, CircularProgress } from '@material-ui/core'
import { SelectComposto } from 'components/SelectComposto/SelectComposto'
import { ModalConfirmacao } from 'components/ModalConfirmacao'
import { useStyles } from './FormVestigioFixado.styles'
import { useFormVestigioFixado } from './hooks/useFormVestigioFixado'

export const FormVestigioFixado = (props) => {
  const classes = useStyles()
  const { idExameRealizado, idLocal, open, setOpen, setVestigiosFixados, setProcessandoVestigiosFixados } = props

  const {
    tiposVestigiosFixados,
    processandoTiposVestigios,
    values,
    handleChange,
    handleAutocompleteChange,
    handleConfirm,
    formError,
    formState,
  } = useFormVestigioFixado({
    idExameRealizado,
    idLocal,
    open,
    setOpen,
    setVestigiosFixados,
    setProcessandoVestigiosFixados,
  })

  const options = useSelector((state) => state.options)

  const handleCloseForm = () => {
    setOpen(false)
  }

  const caracRestantesLocalizacao = 1000 - (values.localizacao?.length || 0)
  const caracRestantesObservacao = 1000 - (values.observacao?.length || 0)

  return (
    <ModalConfirmacao
      aberto={open}
      onClose={handleCloseForm}
      onConfirm={handleConfirm}
      titulo="DADOS DO VESTÍGIO FIXADO"
      confirmarLabel="Confirmar"
      cancelarLabel="Cancelar"
      confirmarColor="primary"
      disabled={formError()}
      maxWidth="sm"
      fullWidth
    >
      {processandoTiposVestigios ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container spacing={1} className={classes.containerCampos}>
          <Grid item md={12} sm={12} xs={12}>
            <SelectComposto
              formState={formState}
              nomePropriedadeInputText="tipoInputText"
              nomePropriedadeSelect="tipo"
              options={tiposVestigiosFixados || null}
              md={12}
              sm={12}
              handleChangeOption={handleAutocompleteChange}
              handleChangeInputText={handleChange}
              labelSelect="Tipo do vestígio"
              required
              shrink
            />
          </Grid>
          {values.tipo &&
            ['ARMA_DE_FOGO', 'CARTUCHO', 'ESTOJO', 'PROJETIL'].includes(values.tipo.cod) && (
              <>
                <Grid item md={12} sm={12} xs={12}>
                  <SelectComposto
                    md={6}
                    sm={6}
                    formState={formState}
                    nomePropriedadeSelect="marca"
                    nomePropriedadeInputText="marcaInputText"
                    options={options.fabricanteCartucho}
                    handleChangeOption={handleAutocompleteChange}
                    handleChangeInputText={handleChange}
                    labelSelect="Marca"
                    shrink
                  />
                </Grid>
                <Grid item md={12} sm={12} xs={12}>
                  <SelectComposto
                    md={6}
                    sm={6}
                    formState={formState}
                    nomePropriedadeSelect="calibre"
                    nomePropriedadeInputText="calibreInputText"
                    options={options.calibreNominalCartucho}
                    handleChangeOption={handleAutocompleteChange}
                    handleChangeInputText={handleChange}
                    labelSelect="Calibre"
                    shrink
                  />
                </Grid>
              </>
            )}

          <Grid item md={12} sm={12} xs={12} className={classes.field}>
            <Grid item md={4} sm={6} xs={12}>
              <TextField
                fullWidth
                label="Quantidade"
                name="quantidade"
                variant="outlined"
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true,
                }}
                value={values.quantidade}
              />
            </Grid>
          </Grid>

          <Grid item md={12} sm={12} xs={12} className={classes.field}>
            <TextField
              fullWidth
              variant="outlined"
              label="Localização do vestígio na cena do caso"
              name="localizacao"
              onChange={handleChange}
              value={values.localizacao}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography variant="caption">
              Caracteres restantes: {caracRestantesLocalizacao}
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12} className={classes.field}>
            <TextField
              fullWidth
              variant="outlined"
              label="Observação (informações adicionais)"
              name="observacao"
              onChange={handleChange}
              value={values.observacao}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Typography variant="caption">
              Caracteres restantes: {caracRestantesObservacao}
            </Typography>
          </Grid>
        </Grid>
      )}
    </ModalConfirmacao>
  )
}

FormVestigioFixado.propTypes = {
  idExameRealizado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idLocal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setVestigiosFixados: PropTypes.func.isRequired,
  setProcessandoVestigiosFixados: PropTypes.func.isRequired,
}
